<script setup lang="ts">
import type { ISegmentControlsOption } from '../../models/segment-control-option';

import LabelError from '../LabelError.vue';
import LabelBase from '../LabelBase.vue';

defineProps<{
  modelValue?: string;
  options: ISegmentControlsOption[];
  label?: string;
  error?: string;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void;
}>();
</script>

<template>
  <div v-if="options?.length" class="segment-control">
    <LabelBase :label="label" />

    <div :class="['segment-control__buttons', error ? 'segment-control__buttons_error' : '']">
      <button
        v-for="option in options"
        :key="option.value"
        :selected="option.value === modelValue"
        @click="$emit('update:modelValue', option.value)"
      >
        {{ option.label }}
      </button>
    </div>

    <LabelError class="segment-control__error" :error-text="error" />
  </div>
</template>

<style lang="stylus" scoped>
.segment-control
  display flex
  flex-direction column
  gap 8px
  position relative
  cursor text

  &__error
    position absolute
    bottom -18px
    left 0
    right 0

  &__buttons
    display flex
    overflow hidden
    border-radius var(--rounding150)
    border: solid 1px var(--border-regular)
    height 38px

    &_error
      border solid 1px var(--border-negative)!important

    & button
      font-family var(--typography-font)
      font-size: 14px
      outline none
      text-decoration none
      box-shadow none
      display flex
      cursor pointer
      align-items center
      transition-duration .2s
      text-align center
      justify-content center
      background-color white
      color var(--text-primary)
      white-space nowrap
      width 100%
      padding 0 20px
      &:hover
        background-color var(--button-secondary-neutral-onprimary-hovered)

      &:nth-of-type(n+2)
        border-left solid 1px var(--border-regular)

      &[selected="true"]
        background-color var(--button-secondary-neutral-onprimary-hovered)
</style>
